import React from 'react'

import { AdviceSpotlightProps } from './AdviceSpotlight.types'
import { sanitizeHTML } from '../../../../utils/common-utils'

export const AdviceSpotlight = (props: AdviceSpotlightProps) => {
  const { heading, eyebrow, callout, description, testId, shouldGrow } = props
  const horizontalRuleClass =
    'AdviceSpotlight-horizontalRule u-border u-borderWidthLarge u-borderTop AdviceSpotlight-borderRadius'

  return (
    <div
      className={`AdviceSpotlight u-adel-reset u-sizeConstrained ${
        shouldGrow ? ' u-flexGrow' : ''
      }`}
      data-testid={testId ? `${testId}` : undefined}>
      <div
        className={`u-flex u-flexAlignItemsCenter u-flexJustifyCenter ${
          heading ? 'u-paddingBottom32' : 'u-paddingBottom40'
        }`}>
        <hr className={horizontalRuleClass} />
        {heading && (
          <>
            <h3 className='AdviceSpotlight-headline u-paddingHoriz20 u-sm-paddingHoriz8 u-textPrimary u-textMedium u-textSizeMsrp2 u-textColorNeutral u-textLineHeightHeading u-textCenter'>
              {heading}
            </h3>
            <hr className={horizontalRuleClass} />
          </>
        )}
      </div>
      <div className={`u-paddingHoriz40 u-sm-paddingHoriz0`}>
        {eyebrow && (
          <p
            className='Type-5 u-textEyebrow u-textPrimary u-paddingBottom8'
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(eyebrow) }}></p>
        )}
        {callout && (
          <p
            className={`u-textSecondary u-textNormal u-textColorMidnightBlue u-textSizeMsrp4 u-textLineHeightHeading ${
              description ? 'u-paddingBottom8' : 'u-paddingBottom40'
            } ${eyebrow ? '' : 'u-paddingTop8'}`}>
            {callout}
          </p>
        )}
        {description && (
          <p
            className='AdviceSpotlight-description Content u-textPrimary u-textNormal u-textSizeMsr u-textColorNeutral u-textDefault u-paddingBottom40'
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(description?.content ?? '') }}></p>
        )}
      </div>
      <div className='u-flex u-flexAlignItemsCenter u-flexJustifyCenter'>
        <hr className={horizontalRuleClass} />
      </div>
    </div>
  )
}
